export default __webpack_public_path__ + "static/media/Prancheta 2.60bae079.svg";